import React from "react";

const MaskText = ({ text, count, maskChar }) => {

  if (!text) return "-";

  if(text.length <= count) return text;

  const visiblePart = text.slice(0, count);
  const maskedPart = maskChar.repeat(3);

  return <>{visiblePart + maskedPart}</>;
};

export default MaskText;